<template>

    <div>
        <transition name="slide-right" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>

</template>

<script>
import appMixin from "./mixins/app-mixin"

export default {
  name: "Application",
  mixins : [appMixin],
  computed: {
  },
  watch: {},
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss">
</style>
